// extracted by mini-css-extract-plugin
module.exports = {"app":"_8535","tv":"_6929","shareGuide":"_5487","text":"_517","tabbar":"_7273","item":"_19081","icon":"_4902","label":"_2438","current":"_12574","special":"_9305"};